const paths = {
  not_found: "/not-found",
  login: "/login",
  home: "/home",
  searchPsi: "/buscar-psi",
  psiDetail: "/psi",
  scheduleDate: "/data-da-sessao",
  custom_schedule: "/horario-avulso",
  checkout: "/checkout",
  callScreen: "/sessao-live",
  settings: "/aceites",
  // o Blog fica dentro do "Mais" (o /blog antigo redireciona)
  blog: "/mais/blog",
  chats: "/chats",
  more: "/mais",
  passwordReset: "/redefinir-senha",
  appointments: {
    list: "/sessoes",
    detail: "/sessoes/detalhes",
  },
  register: {
    base: "/cadastro",
    info: "/cadastro/informacoes",
    nickname: "/cadastro/apelido",
    children: {
      info: "informacoes",
      nickname: "apelido",
    },
  },
};

export default paths;
